import React from 'react';
import { connect } from "react-redux";
import updateTaxRate from '../../../../API/Provider/PutTaxRate'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from './../../../../Global/loader'
import { withNamespaces } from 'react-i18next';
import { Form, Row, Col, Button } from 'react-bootstrap'

class UpdatePorezi extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
    }

    state={
        loading: false
    }

    componentDidMount = async () => {
        document.title = this.props.t("Tax Rate") + "-" + this.props.t("Update")         
         
        await this.setState({
            loading: false            
        })
    }
    
    handleChange = async (e) => {
        await this.props.mapState("CHANGE_PROVIDER_ONE_TAX_RATE_DETAILS", e.target) 
    }

    submitUpdate = async (e) => {        
        this.setState({ loading: true })
        e.preventDefault()        

        let createPP = await updateTaxRate(
            this.props.oneTaxRate.uuid,            
            this.props.oneTaxRate.tax_rate_mark,
            this.props.oneTaxRate.tax_rate_description,
            this.props.oneTaxRate.tax_rate,
            this.props.oneTaxRate.country_uuid,
            this.props.oneTaxRate.note
        )

        if(createPP.data.status === 200){ 
            store.addNotification({
                title: this.props.t('Success!'),
                message: this.props.t("Creating was successful"),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
            this.props.goBack()
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t("There was an error changing the tax, please try again"),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        
    }

    handleCountryChange(e){  
        this.setState({
            country: e
        })                  
    }
   
    render(){  
        const { t } = this.props
        
        return (
            <div>
                {this.state.loading ?
                    <Loader />
                :
                <Form className="form-container">
                    <Row>        
                        <Col sm={12} lg={6} xl={4}>                            
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="Form.Label" column sm={2} md={4}>{t('Form.Label')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                            id="tax_rate_mark"                          
                                            type="text"
                                            value={this.props.oneTaxRate.tax_rate_mark}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </Col>
                            </Form.Group>
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="description" column sm={2} md={4}>{t('Description')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="tax_rate_description"  
                                        type="text"
                                        value={this.props.oneTaxRate.tax_rate_description}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="tax_rate" column sm={2} md={4}>{t('Tax Rate')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <Form.Control
                                        id="tax_rate"  
                                        type="number"
                                        min={0}
                                        value={this.props.oneTaxRate.tax_rate}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="note" column sm={2} md={4}>{t('Note')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                        id="note"                          
                                        type="text"
                                        value={this.props.oneTaxRate.note}
                                        onChange={e => this.handleChange(e)}                                           
                                    />
                                </Col>
                            </Form.Group>

                            <Col sm={12} className="p-0 text-center">
                                <Button                                      
                                    className="btnSpremi" 
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </Col>                                  
                        </Col>                        
        
                        
                    </Row>           
                    
                    <Row className='back-button-container'>
                        <Button 
                            variant='default'
                            onClick={() => this.props.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                        
                        </Button>
                    </Row>
                </Form>
                }
            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneTaxRate: state.provider.oneTaxRate
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(UpdatePorezi));